import { useEffect, useRef } from "react";

const HogHoofPrint = ({ x, y, rotation, size = 36, mirror = false }) => {
  const sx = mirror ? -1 : 1;
  return (
    <g transform={`translate(${x}, ${y}) rotate(${rotation}) scale(${sx}, 1)`} className="animal-track">
      <ellipse cx={-5} cy={0} rx={4.5} ry={size * 0.3} fill="currentColor" transform="rotate(-12)" />
      <ellipse cx={5} cy={0} rx={4.5} ry={size * 0.3} fill="currentColor" transform="rotate(12)" />
      <circle cx={-7} cy={-size * 0.36} r={2.2} fill="currentColor" />
      <circle cx={7} cy={-size * 0.36} r={2.2} fill="currentColor" />
    </g>
  );
};

const RaccoonPawPrint = ({ x, y, rotation, size = 32, mirror = false }) => {
  const sx = mirror ? -1 : 1;
  return (
    <g transform={`translate(${x}, ${y}) rotate(${rotation}) scale(${sx}, 1)`} className="animal-track">
      <ellipse cx={0} cy={3} rx={size * 0.3} ry={size * 0.22} fill="currentColor" />
      <ellipse cx={-size * 0.28} cy={-size * 0.15} rx={2.5} ry={4.5} fill="currentColor" transform="rotate(-20)" />
      <ellipse cx={-size * 0.13} cy={-size * 0.3} rx={2.2} ry={4} fill="currentColor" transform="rotate(-8)" />
      <ellipse cx={size * 0.05} cy={-size * 0.34} rx={2.2} ry={4} fill="currentColor" />
      <ellipse cx={size * 0.22} cy={-size * 0.27} rx={2.2} ry={3.8} fill="currentColor" transform="rotate(10)" />
      <ellipse cx={size * 0.35} cy={-size * 0.13} rx={2} ry={3.5} fill="currentColor" transform="rotate(22)" />
    </g>
  );
};

export const AnimalTracksHog = ({ className = "" }) => {
  /* Walking LEFT to RIGHT: toes face right = rotation ~90°.
     Alternate y for left/right foot gait. Slight angle variation for natural feel. */
  const prints = [
    { x: 30,  y: 105, rotation: -85, mirror: false },
    { x: 150, y: 195, rotation: -92, mirror: true },
    { x: 270, y: 100, rotation: -88, mirror: false },
    { x: 390, y: 200, rotation: -94, mirror: true },
    { x: 510, y: 98,  rotation: -86, mirror: false },
    { x: 630, y: 205, rotation: -91, mirror: true },
    { x: 750, y: 102, rotation: -87, mirror: false },
    { x: 870, y: 198, rotation: -93, mirror: true },
  ];

  return (
    <svg
      className={`absolute inset-0 w-full h-full pointer-events-none track-hog ${className}`}
      viewBox="0 0 1000 300"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <g fill="#1E293B">
        {prints.map((p, i) => (
          <HogHoofPrint key={i} x={p.x} y={p.y} rotation={p.rotation} mirror={p.mirror} />
        ))}
      </g>
    </svg>
  );
};

export const AnimalTracksRaccoon = ({ className = "" }) => {
  /* Walking RIGHT to LEFT: toes face left = rotation ~-90° (270°).
     Alternate y for left/right foot gait. */
  const prints = [
    { x: 960, y: 108, rotation: -88, mirror: false },
    { x: 840, y: 198, rotation: -93, mirror: true },
    { x: 720, y: 102, rotation: -86, mirror: false },
    { x: 590, y: 202, rotation: -91, mirror: true },
    { x: 470, y: 96,  rotation: -89, mirror: false },
    { x: 340, y: 205, rotation: -94, mirror: true },
    { x: 220, y: 105, rotation: -87, mirror: false },
    { x: 90,  y: 195, rotation: -92, mirror: true },
  ];

  return (
    <svg
      className={`absolute inset-0 w-full h-full pointer-events-none track-raccoon ${className}`}
      viewBox="0 0 1000 300"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
    >
      <g fill="#1E293B">
        {prints.map((p, i) => (
          <RaccoonPawPrint key={i} x={p.x} y={p.y} rotation={p.rotation} mirror={p.mirror} />
        ))}
      </g>
    </svg>
  );
};
